import React = require('react');
import { Query } from 'react-apollo';
import {
  WorkbookCustomSqlQuery,
  WorkbookCustomSqlQueryVariables
} from '../../../gen-src/queries/WorkbookCustomSqlQuery';
import { WorkbookCustomSqlQueryGql } from '../../queries/WorkbookCustomSqlQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { CustomSQLTable, CustomSqlTextLink } from './CustomSqlDialog';

export type WorkbookCustomSqlQueryWrapperProps = {
  readonly workbookId: string;
  readonly embeddedDatasourceId: string;
};

export function WorkbookCustomSqlQueryWrapper(props: WorkbookCustomSqlQueryWrapperProps): JSX.Element {

  return (
    <Query<WorkbookCustomSqlQuery, WorkbookCustomSqlQueryVariables>
      query={WorkbookCustomSqlQueryGql}
      variables={{ vizportalUrlId: props.workbookId, selectedEmbeddedDatasourceId: props.embeddedDatasourceId }}
    >
      {result => renderQueryResult(result, {
        renderData: renderCustomSqlQueries
      })}
    </Query>
  )
}

function renderCustomSqlQueries(data: WorkbookCustomSqlQuery): JSX.Element | null {
  const workbook = data && data.workbooks ? data.workbooks[0] : null;
  const embeddedDatasource = workbook && workbook.embeddedDatasources ? workbook.embeddedDatasources[0] : null;
  if (!workbook || !embeddedDatasource) {
    return null;
  }

  const embeddedDatasourceName = embeddedDatasource.name;
  const customSqlMap = new Map();
  embeddedDatasource.fields.forEach((field) => {
    if (field.__typename === 'ColumnField') {
      field.columns.forEach((column) => {
        if (column.table?.__typename === 'CustomSQLTable') {
          customSqlMap.set(column.table.id, column.table);
        }
      });
    }
  });

  if (customSqlMap.size === 0) {
    return null;
  }

  const customSqlTables: Array<CustomSQLTable> = Array.from(customSqlMap.values());
  return (
    <CustomSqlTextLink
      containsUnsupportedCustomSql={customSqlTables.some(t => t.isUnsupportedCustomSql ?? false)}
      customSQLTables={customSqlTables}
      contentType={workbook.__typename}
      selectedDropdownName={embeddedDatasourceName}
    />
  );
}
